import { DriftWall } from "./components/DriftWall";
import { NotifyForm } from "./components/NotifyForm";
import { useMediaQuery } from "./lib/use-media-query";
import { wallImages } from "./lib/wall-images";
import "./index.css";

const models = [
  "Nano Banana",
  "Flux",
  "Midjourney",
  "DALL·E",
  "Stable Diffusion",
  "Imagen",
  "Ideogram",
  "Recraft",
  "Seedream",
];

export function App() {
  // Narrow screens only ever see a few columns, so don't pay to render the rest.
  const narrow = useMediaQuery("(max-width: 639px)");
  const medium = useMediaQuery("(max-width: 1023px)");
  const columns = narrow ? 4 : medium ? 6 : 8;

  return (
    <div className="pixub-stage relative min-h-dvh w-full overflow-hidden font-sans text-white">
      <div className="absolute inset-0">
        <DriftWall
          images={wallImages}
          columns={columns}
          tileWidth={200}
          tileHeight={200}
          gap={18}
          radius={16}
          tilt={16}
          turn={-14}
          depth={120}
          speed={42}
          variance={0.45}
          parallax={0.6}
          fade={0.6}
          dim={0.7}
          overlayColor="#0b0912"
          className="h-full w-full"
        />
      </div>

      {/* Centre vignette, so the copy always reads against the moving imagery. */}
      <div className="pixub-vignette pointer-events-none absolute inset-0" />

      <main className="pointer-events-none relative z-10 flex min-h-dvh flex-col items-center justify-center px-6 py-24 text-center">
        <h1 className="font-display text-[clamp(38px,6vw,72px)] leading-[1.02] font-extrabold tracking-[-0.02em] text-balance">
          <span className="block">PIXUB.COM</span>
          <span className="block text-lilac">EVERY IMAGE MODEL</span>
        </h1>

        <p className="mt-5 max-w-[460px] text-[17px] leading-relaxed text-mist text-pretty">
          Coming soon. We're putting the finishing touches on the studio. Generate with every leading image model, from
          a single prompt box.
        </p>

        <ul className="mt-10 flex max-w-[520px] flex-wrap justify-center gap-2">
          {models.map(name => (
            <li
              key={name}
              className="rounded-full border border-white/10 bg-white/5 px-3.5 py-1.5 text-[13px] font-medium text-mist backdrop-blur-sm"
            >
              {name}
            </li>
          ))}
        </ul>

        <NotifyForm />
      </main>

      <footer className="pointer-events-none absolute inset-x-0 bottom-0 z-10 p-6 text-center text-[13px] text-white/35">
        © {new Date().getFullYear()} Pixub
      </footer>
    </div>
  );
}

export default App;
